/**
 * extensions.code values the API stamps on document-upload rejections whose
 * message is written for the end user. The api↔oak wire contract for those
 * rejections: the API sets them (toGraphQLDocumentUploadError) and Oak's
 * uploaders match on them (getMessageForErrorCodes), so both import from here
 * rather than repeating the strings.
 */
export const ENCRYPTED_PDF_ERROR_CODE = "ENCRYPTED_PDF";
export const FILETYPE_MISMATCH_ERROR_CODE = "FILETYPE_MISMATCH";

/** Every code above, for uploaders that surface all of them the same way. */
export const DOCUMENT_UPLOAD_USER_ERROR_CODES: string[] = [
  ENCRYPTED_PDF_ERROR_CODE,
  FILETYPE_MISMATCH_ERROR_CODE,
];
